export default __webpack_public_path__ + "static/media/gallery-wip-emitter-shroud_01.cc61f32e.jpg";